import TextWinds from '../../../components/common/TextWinds';
import { Button } from 'antd';
import { openNewWindow } from '../../../api/utils/util-func';
import CreateRecitationWrapper from '../../../components/lms/recitation/create/CreateRecitationWrapper';
import { AssignmentType } from '../../../constants/types/lms/type';
import { AssignmentRecitationItem } from '../../../constants/types/lms/recitation/type';

type Book = {
  id: string;
  title: string;
  type: AssignmentType;
};

type Lesson = {
  id: string;
  bookId: string;
  title: string;
};

export type LessonWithAssignments = Lesson & {
  assignments?: AssignmentRecitationItem[];
  isAssignmentLoaded?: boolean;
};

export type BookNode = Book & {
  lessons?: LessonWithAssignments[];
  isLessonLoaded?: boolean;
  assignments?: AssignmentRecitationItem[];
  isAssignmentLoaded?: boolean;
};

export type SelectedAssignment = AssignmentRecitationItem & {
  bookTitle: string;
  lessonTitle?: string;
};

/**
 * 개편 LMS (교사) - AI인증제 관리 > AI인증제 내주기 페이지 > 상단 & 콘텐츠
 */
const CreateRecitation = () => {
  return (
    <div className="flex w-full flex-col pt-6 xl:px-5">
      <header className="flex flex-col gap-3 px-5 xl:flex-row xl:items-center xl:justify-between xl:px-0">
        <div className="min-w-0">
          <TextWinds type="title_h2" xlType="title_h3" className="mb-[2px]">
            AI인증제 내주기
          </TextWinds>

          <TextWinds type="content_body3">
            학생에게 AI인증제 과제를 등록해 주세요. 학생은 본인 계정으로
            접속하여 AI인증제를 이용할 수 있습니다.
          </TextWinds>
        </div>

        <Button
          type="primary"
          className="shrink-0 rounded-lg !border-purple5 !bg-purple5 px-4 hover:!border-purple6 hover:!bg-purple6"
          onClick={() => {
            const url = 'https://cafe.naver.com/jemm/5131';
            openNewWindow(url);
          }}
        >
          이용 안내
        </Button>
      </header>

      <CreateRecitationWrapper />
    </div>
  );
};

export default CreateRecitation;
